import React from "react";
import PropTypes from "prop-types";
import FileWhite from "../icons/file-white.svg";
import FileGrey from "../icons/file-grey.svg";

const OtherDetailStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? FileWhite : FileGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="File Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};



OtherDetailStepIcon.propTypes = {
  completed: PropTypes.any,
  show: PropTypes.bool,
};

export default OtherDetailStepIcon;
